var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.$store.getters.loadingMap[_vm.$store.getters.currentPath],
          expression: "$store.getters.loadingMap[$store.getters.currentPath]",
        },
      ],
      staticStyle: { height: "430px" },
    },
    [
      _c(
        "el-row",
        [
          _c(
            "span",
            { staticStyle: { "font-weight": "600", "margin-right": "20px" } },
            [_vm._v(_vm._s(_vm.$t("panel.outer_param_set")))]
          ),
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.outerParams.checked,
                callback: function ($$v) {
                  _vm.$set(_vm.outerParams, "checked", $$v)
                },
                expression: "outerParams.checked",
              },
            },
            [_vm._v(_vm._s(_vm.$t("panel.enable_outer_param_set")))]
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c(
            "el-row",
            { staticClass: "preview" },
            [
              _c(
                "el-col",
                {
                  staticStyle: { height: "100%", "overflow-y": "hidden" },
                  attrs: { span: 8 },
                },
                [
                  _c("el-row", { staticClass: "tree-head" }, [
                    _c(
                      "span",
                      { staticStyle: { float: "left", "margin-left": "30px" } },
                      [_vm._v(_vm._s(_vm.$t("panel.param_name")))]
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: { float: "right", "margin-right": "10px" },
                      },
                      [_vm._v(_vm._s(_vm.$t("panel.enable_param")))]
                    ),
                  ]),
                  _c(
                    "el-row",
                    { staticClass: "tree-content" },
                    [
                      _c("el-tree", {
                        ref: "outerParamsInfoTree",
                        attrs: {
                          data: _vm.outerParamsInfoArray,
                          "node-key": "id",
                          "highlight-current": "",
                          props: _vm.treeProp,
                        },
                        on: { "node-click": _vm.nodeClick },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var node = ref.node
                              var data = ref.data
                              return _c(
                                "span",
                                { staticClass: "custom-tree-node" },
                                [
                                  _c("span", [
                                    _c(
                                      "span",
                                      { staticStyle: { "margin-left": "6px" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            size: "mini",
                                            placeholder: _vm.$t(
                                              "panel.input_param_name"
                                            ),
                                          },
                                          model: {
                                            value: data.paramName,
                                            callback: function ($$v) {
                                              _vm.$set(data, "paramName", $$v)
                                            },
                                            expression: "data.paramName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "span",
                                          { staticClass: "auth-span" },
                                          [
                                            _c("el-checkbox", {
                                              staticStyle: {
                                                "margin-right": "10px",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.sourceFieldCheckedChange(
                                                    data
                                                  )
                                                },
                                              },
                                              model: {
                                                value: data.checked,
                                                callback: function ($$v) {
                                                  _vm.$set(data, "checked", $$v)
                                                },
                                                expression: "data.checked",
                                              },
                                            }),
                                            _c("el-button", {
                                              attrs: {
                                                icon: "el-icon-delete",
                                                type: "text",
                                                size: "small",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeOuterParamsInfo(
                                                    node,
                                                    data
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "tree-bottom" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "mini",
                            type: "success",
                            icon: "el-icon-plus",
                            round: "",
                          },
                          on: { click: _vm.addOuterParamsInfo },
                        },
                        [_vm._v(_vm._s(_vm.$t("panel.add_param")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "preview-show", attrs: { span: 16 } },
                [
                  _vm.outerParamsInfo
                    ? _c(
                        "el-row",
                        [
                          _c(
                            "el-row",
                            { staticClass: "top_border" },
                            [
                              _c(
                                "el-row",
                                { staticStyle: { "margin-top": "10px" } },
                                [
                                  _c("el-col", { attrs: { span: 11 } }, [
                                    _c("div", { staticClass: "ellip" }, [
                                      _vm._v(_vm._s(_vm.$t("panel.link_view"))),
                                    ]),
                                  ]),
                                  _c("el-col", { attrs: { span: 11 } }, [
                                    _c("div", { staticClass: "ellip" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("panel.link_view_field"))
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                {
                                  staticStyle: {
                                    height: "266px",
                                    "overflow-y": "auto",
                                  },
                                },
                                _vm._l(
                                  _vm.outerParamsInfo.targetViewInfoList,
                                  function (targetViewInfo, index) {
                                    return _c(
                                      "el-row",
                                      { key: index },
                                      [
                                        _c("el-col", { attrs: { span: 11 } }, [
                                          _c(
                                            "div",
                                            { staticClass: "select-filed" },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    placeholder: _vm.$t(
                                                      "fu.search_bar.please_select"
                                                    ),
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.viewInfoOnChange(
                                                        targetViewInfo
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      targetViewInfo.targetViewId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        targetViewInfo,
                                                        "targetViewId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "targetViewInfo.targetViewId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.currentLinkPanelViewArray,
                                                  function (item) {
                                                    return _c(
                                                      "el-option",
                                                      {
                                                        key: item.id,
                                                        attrs: {
                                                          label: item.name,
                                                          value: item.id,
                                                        },
                                                      },
                                                      [
                                                        item.isPlugin
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  float: "left",
                                                                },
                                                              },
                                                              [
                                                                _c("svg-icon", {
                                                                  staticStyle: {
                                                                    width:
                                                                      "14px",
                                                                    height:
                                                                      "14px",
                                                                  },
                                                                  attrs: {
                                                                    "icon-class":
                                                                      item.type !==
                                                                      "buddle-map"
                                                                        ? "/api/pluginCommon/staticInfo/" +
                                                                          item.type +
                                                                          "/svg"
                                                                        : item.type,
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  float: "left",
                                                                },
                                                              },
                                                              [
                                                                _c("svg-icon", {
                                                                  staticStyle: {
                                                                    width:
                                                                      "14px",
                                                                    height:
                                                                      "14px",
                                                                  },
                                                                  attrs: {
                                                                    "icon-class":
                                                                      item.type,
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              float: "left",
                                                              "font-size":
                                                                "12px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                        _c("el-col", { attrs: { span: 11 } }, [
                                          _c(
                                            "div",
                                            { staticClass: "select-filed" },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    placeholder: _vm.$t(
                                                      "fu.search_bar.please_select"
                                                    ),
                                                  },
                                                  model: {
                                                    value:
                                                      targetViewInfo.targetFieldId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        targetViewInfo,
                                                        "targetFieldId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "targetViewInfo.targetFieldId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.viewIdFieldArrayMap[
                                                    targetViewInfo.targetViewId
                                                  ],
                                                  function (viewField) {
                                                    return _c(
                                                      "el-option",
                                                      {
                                                        key: viewField.id,
                                                        attrs: {
                                                          label: viewField.name,
                                                          value: viewField.id,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              float: "left",
                                                            },
                                                          },
                                                          [
                                                            viewField.deType ===
                                                            0
                                                              ? _c("svg-icon", {
                                                                  staticClass:
                                                                    "field-icon-text",
                                                                  attrs: {
                                                                    "icon-class":
                                                                      "field_text",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            viewField.deType ===
                                                            1
                                                              ? _c("svg-icon", {
                                                                  staticClass:
                                                                    "field-icon-time",
                                                                  attrs: {
                                                                    "icon-class":
                                                                      "field_time",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            viewField.deType ===
                                                              2 ||
                                                            viewField.deType ===
                                                              3
                                                              ? _c("svg-icon", {
                                                                  staticClass:
                                                                    "field-icon-value",
                                                                  attrs: {
                                                                    "icon-class":
                                                                      "field_value",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            viewField.deType ===
                                                            5
                                                              ? _c("svg-icon", {
                                                                  staticClass:
                                                                    "field-icon-location",
                                                                  attrs: {
                                                                    "icon-class":
                                                                      "field_location",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              float: "left",
                                                              "font-size":
                                                                "12px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                viewField.name
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                        _c("el-col", { attrs: { span: 2 } }, [
                                          _c(
                                            "div",
                                            [
                                              _c("el-button", {
                                                staticStyle: { float: "left" },
                                                attrs: {
                                                  icon: "el-icon-delete",
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteOuterParamsField(
                                                      index
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                              _c(
                                "el-row",
                                { staticClass: "bottom" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "success",
                                        icon: "el-icon-plus",
                                        round: "",
                                      },
                                      on: { click: _vm.addOuterParamsField },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("panel.add_param_link_field")
                                        ) + "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("i", {
                                staticClass:
                                  "icon iconfont icon-edit slot-class",
                                attrs: { slot: "reference" },
                                slot: "reference",
                              }),
                            ],
                            1
                          ),
                          _vm.outerParamsInfo.linkType === "outer"
                            ? _c(
                                "el-row",
                                { staticStyle: { height: "300px" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      autosize: { minRows: 14 },
                                      type: "textarea",
                                      placeholder: _vm.$t(
                                        "panel.input_jump_link"
                                      ),
                                    },
                                    model: {
                                      value: _vm.outerParamsInfo.content,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.outerParamsInfo,
                                          "content",
                                          $$v
                                        )
                                      },
                                      expression: "outerParamsInfo.content",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "el-row",
                        {
                          staticClass: "custom-position",
                          staticStyle: {
                            height: "100%",
                            "background-color": "var(--MainContentBG)",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("panel.select_param")) +
                              "\n        "
                          ),
                        ]
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "root-class" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("commons.cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("commons.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }